module.exports = [
  {
    id: 'UniquePhone',
    label: 'Unique Phone',
    description: 'Matches Locations and Clients that share a phone number if no other Location or Client shares the phone number',
  },
  {
    id: 'Predefined',
    label: 'Predefined',
    description: 'Matches user entered list of location ids to client ids. Input format is "LocationId1->ClientId1, LocationId2->ClientId2" ',
  },
  {
    id: 'MatchAlgo',
    label: 'Match Algorithm',
    description: 'Use Chatmeter\'s standard Match Algorithm to match against advice local listings. Min match can be set between 3 and 7',
    defaultArgs: { minMatch: 7 }
  },
  {
    id: 'ExactNameAndAddress',
    label: 'Name And Address',
    description: 'Matches if the name and address are (approximately) exactly the same. (Case insensitive, after normalization)',
  },
  {
    id: 'StreetAddress',
    label: 'Address',
    description: 'Matches if the location and client have the same full address',
  },
  {
    id: 'PartialAddress',
    label: 'Partial Address',
    description: 'Matches if the location and client have the same street address and zip code',
  },
]
